import { render } from "./message-bubble.vue?vue&type=template&id=7034e244&scoped=true&ts=true"
import script from "./message-bubble.vue?vue&type=script&lang=ts"
export * from "./message-bubble.vue?vue&type=script&lang=ts"

import "./message-bubble.vue?vue&type=style&index=0&id=7034e244&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7034e244"]])

export default __exports__